import React from 'react'

export default function DetectOffline() {
    return (
        <div className="offline position-relative start-0 bottom-25 bg-dark text-warning text-center py-1 px-2 " >You are Offline Now !</div>
    )
}
